export default __webpack_public_path__ + "static/media/gallery_00.067e8a04.jpg";